import { type IAgentProfileForCompanyQuery } from 'application/querySchemas/IAgentProfileForCompanyQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type IAgentProfileForCompanyClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentProfileForCompanyClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentProfileForCompanyQuery implements IAgentProfileForCompanyQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('IAgentProfileForCompanyClient')
        public readonly agentProfileForCompanyClient: IAgentProfileForCompanyClient,
    ) {}

    public async fetch(agentId: number): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentProfileForCompanyClient.get({
            token: this.companyUserToken.get() || '',
            agent_id: agentId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
